import Service from "../../Services";

const Branch = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      branch_name_th : '',
      branch_name_en : '',
      tag_name : '',
      img_cover_mobile_path : '',
      img_cover_mobile_name : '',
      img_cover_desktop_name : '',
      img_cover_desktop_path : '',
      service_area_image : '',
      mobile_path_show : '',
      desktop_path_show : '',
      service_area_image_show : '',
    },
  },
  mutations : {
    GET_FORM_BRANCH : (state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA : (state)=>{
      state.form = {
        branch_id : '',
        branch_name_th : '',
        branch_name_en : '',
        tag_name : '',
        img_cover_mobile_path : '',
        img_cover_mobile_name : '',
        img_cover_desktop_name : '',
        img_cover_desktop_path : '',
        service_area_image : '',
        mobile_path_show : '',
        desktop_path_show : '',
        service_area_image_show : '',
      }
    }
  },
  actions : {
    getBranch({commit},page){
      return Service.BranchAPI.getBranch(page);
    },
    showBranch({commit},id){
      return Service.BranchAPI.showBranch(id);
    },
    saveBranch({commit},{id,data}){
      if(id){ //update
        return Service.BranchAPI.updateBranch(id,data);
      }else{ //create
        return Service.BranchAPI.createBranch(data);
      }
    },
    deleteBranch({commit},id){
      return Service.BranchAPI.deleteBranch(id);
    },
    setFormBranch({commit},res){
      commit('GET_FORM_BRANCH',res);
    },
    clearFormData({commit}){
      commit("CLEAR_FORM_DATA");
    },
    getBranchAll() {
      return Service.BranchAPI.getBranchAll();
    }
  },
}
export default Branch
